import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { LocationRepository }   from 'Domain/Repositories';
import { message }              from 'antd';

export const createLocationEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.createLocationRequest.type),
    mergeMap(action => from(LocationRepository.create(action.payload.formData))
      .pipe(
        mergeMap((location) => {
          message.success('Location wurde erfolgreich erstellt');
          return from([
            Actions.createLocationSuccess({ location })
          ]);
        }),
        catchError(error => {
          return from([
            Actions.createLocationFailure({ error }),
          ]);
        })
      )
    ),
  );
};
